import log from 'loglevel'

// 开发环境默认 debug；生产环境默认 warn。可通过 VUE_APP_LOG_LEVEL 覆盖。
const logLevel =
  process.env.VUE_APP_LOG_LEVEL ||
  (process.env.NODE_ENV === 'production' ? 'warn' : 'debug')
log.setLevel(logLevel)

// 2. 插件式增强：添加时间戳和颜色样式
const originalFactory = log.methodFactory
log.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName)

  return (...args) => {
    const timestamp = new Date().toLocaleTimeString()
    const label = methodName.toUpperCase()

    // 不同级别的颜色配置
    const colors = {
      debug: '#7f8c8d',
      info: '#2ecc71', // 绿色
      warn: '#f39c12', // 橙色
      error: '#e74c3c' // 红色
    }

    // 开发环境 debug 走 console.info，避免 Chrome Default levels 过滤 console.debug
    const output =
      methodName === 'debug' && process.env.NODE_ENV !== 'production'
        ? console.info.bind(console)
        : rawMethod

    output(
      `%c[${timestamp}] [${label}]`,
      `color: ${colors[methodName]}; font-weight: bold;`,
      ...args
    )
  }
}

log.setLevel(log.getLevel())

export default log
